module.exports = __webpack_public_path__ + "img/greenTick.4db85719.svg";